(function($) {
    var $fn = $(".comp_category");

    if ($fn.length) {
        fn_scroll();
        $(document).on("scroll", fn_scroll);
        function fn_scroll() {
            var $scroll = $(document).scrollTop() + 100;
            $fn.find(".wrp_comp_body .elm_item").each(function () {
                var $el = $(this),
                    $index = $el.index(),
                    $nav = $fn.find(".wrp_comp_nav a"),
                    $nav_index = $nav.eq($index);
                if ($el.offset().top <= $scroll && $el.offset().top + $el.height() > $scroll && !$nav_index.hasClass("mod--active")) {
                    $nav.removeClass("mod--active");
                    $nav_index.addClass("mod--active");
                }
            });
        }
    }
})(jQuery);